import {GET_ACCOUNT, CREATE_ACCOUNT, UPDATE_ACCOUNT} from 'admin/gql/Account.gql'
import {RECALCULATE_ACCOUNTS} from 'admin/gql/Accounts.gql'
import {useQuery, useMutation} from 'admin/lib/apollo'

export default (organisationId, accountId) => {
  const variables = {organisationId, accountId}

  const {
    data: {account = {}} = {},
    error: getError,
    loading: getLoading
  } = useQuery(GET_ACCOUNT, {variables, skip: !accountId})

  const [create, {error: createError, loading: createLoading}] = useMutation(CREATE_ACCOUNT, {
    variables,
    refetchQueries: ['GetAccounts'],
    flash: 'Account created'
  })

  const [update, {error: updateError, loading: updateLoading}] = useMutation(UPDATE_ACCOUNT, {
    variables,
    flash: 'Account updated'
  })

  const [recalculate] = useMutation(RECALCULATE_ACCOUNTS, {
    variables: {organisationId},
    flash: 'Account recalculated'
  })

  return {
    account,
    errors: getError || createError || updateError || {},
    loading: getLoading || createLoading || updateLoading,
    create,
    update,
    recalculate
  }
}
